export var VERSION_COOKIE = "PBFEVersion";
export var GRAPH_URL_COOKIE = "PBFEGraphUrl";
export var API_GW_URL_COOKIE = "PBFEAPIGWUrl";
export default { VERSION_COOKIE: VERSION_COOKIE, GRAPH_URL_COOKIE: GRAPH_URL_COOKIE, API_GW_URL_COOKIE: API_GW_URL_COOKIE };
